import {CartIconApp} from '../CartIconApp/CartIconApp';

export default CartIconApp;
